import * as constants from './constants'

const appInfo = state => state.get('externalApp').appInfo
const appCodes = state => state.get('externalApp').appCodes
const status = state => state.get('externalApp').status

export const getAppInfo = (clientId, state) => appInfo(state).get(clientId)
export const getAppCode = (clientId, state) => appCodes(state).get(clientId)

export const getAppInfoFailed = (clientId, state) => status(state).getIn(['appInfo', clientId]) === constants.FETCH_OAUTH_APP_INFO_FAILED
export const getAppCodeFailed = (clientId, state) => status(state).getIn(['appCode', clientId]) === constants.FETCH_OAUTH_CODE_FAILED



// WEBPACK FOOTER //
// ./src/scripts/app/modules/externalApp/selectors.js